import { fromPromise } from 'xstate';
import { apolloClient } from '@/lib/apollo';
import {
  CorrectFilingMutation,
  CorrectRejectedFilingMutation,
  FindFirmFilingsQuery,
  OpenFilingMutation,
  ViewFilingQuery,
} from '@/lib/gql/__generated__/canonical-documents';
import type { CorrectFilingInput, CorrectRejectedFilingInput, OpenFilingInput } from '@/lib/gql/__generated__/graphql';

const mutationError = (response: { success: boolean; error?: { message?: string | null } | null }) => {
  if (!response.success) throw new Error(response.error?.message ?? 'The filing could not be saved.');
};

export const findFirmFilingsActor = fromPromise(async () => {
  const result = await apolloClient.query({ query: FindFirmFilingsQuery });
  return result.data?.findFirmFilings ?? [];
});

export const viewFilingActor = fromPromise(async ({ input }: { input: string }) => {
  const result = await apolloClient.query({ query: ViewFilingQuery, variables: { filingId: input } });
  return result.data?.viewFiling ?? null;
});

export const openFilingActor = fromPromise(async ({ input }: { input: Omit<OpenFilingInput, 'filingId'> }) => {
  const filingId = crypto.randomUUID();
  const result = await apolloClient.mutate({
    mutation: OpenFilingMutation,
    variables: {
      input: {
        clientId: input.clientId,
        filingCredentialId: input.filingCredentialId,
        filingId,
        taxRuleSetId: input.taxRuleSetId,
      },
    },
  });
  mutationError(result.data?.openFiling ?? { success: false });
  return filingId;
});

export const correctFilingActor = fromPromise(async ({ input }: { input: CorrectFilingInput }) => {
  const result = await apolloClient.mutate({
    mutation: CorrectFilingMutation,
    variables: { input: { filingId: input.filingId, correctionNote: input.correctionNote } },
  });
  mutationError(result.data?.correctFiling ?? { success: false });
  return true;
});

export const correctRejectedFilingActor = fromPromise(async ({ input }: { input: CorrectRejectedFilingInput }) => {
  const result = await apolloClient.mutate({
    mutation: CorrectRejectedFilingMutation,
    variables: { input: { filingId: input.filingId, correctionNote: input.correctionNote } },
  });
  mutationError(result.data?.correctRejectedFiling ?? { success: false });
  return true;
});
